import { useUIComponents } from "../providers/UIComponentsProvider/useUIComponents";

export const useShowAlert = () => {
  const { showAlert } = useUIComponents();

  return showAlert;
};
